import { render, staticRenderFns } from "./OneOffLandingPage.vue?vue&type=template&id=dea1aeb6&scoped=true"
import script from "./OneOffLandingPage.vue?vue&type=script&lang=js"
export * from "./OneOffLandingPage.vue?vue&type=script&lang=js"
import style0 from "./OneOffLandingPage.vue?vue&type=style&index=0&id=dea1aeb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea1aeb6",
  null
  
)

export default component.exports